import { BaseValidationRuleResolver } from './BaseValidationRuleResolver';

export const lengthValidationRuleResolver: BaseValidationRuleResolver = (
  value,
  rule: { min?: number; max?: number; message?: string }
) => {
  const isValid =
    (rule.min === undefined || value.length >= rule.min) && (rule.max === undefined || value.length <= rule.max);
  if (isValid) {
    return null;
  }

  if (rule.message) {
    return rule.message;
  }

  if (rule.min !== undefined && rule.max !== undefined) {
    return `Must be between ${rule.min} and ${rule.max} long.`;
  }

  if (rule.min !== undefined) {
    return `Must be at least ${rule.min} long.`;
  }

  return `Must be at most ${rule.max} long.`;
};
